<template>
    <div class="ibox-footer">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "IboxFooter"
    }
</script>

<style scoped>

</style>
